<template>
  <div
    class="menu d-flex align-center justify-space-between"
    :class="{ 'is-fixed': !changeColor }"
  >
    <v-container>
      <v-row no-gutters>
        <v-col cols="8" class="show-res my-auto">
          <div @click="toggleSidebar()" elevation="0" fab v-if="!drawer">
            <i class="fas fa-bars p-fs-xxxl text-p-white"></i>
          </div>
        </v-col>
        <v-col cols="4" lg="2" md="2">
          <div class="py-1">
            <v-img :src="config.secondLogoAddress" contain height="50px" />
          </div>
        </v-col>
        <v-col cols="6" lg="8" md="8" class="hide-res">
          <ul
            class="d-flex align-center"
            v-for="mMenu in menu.filter((menu) => menu.name === 'Main')"
            :key="mMenu.id"
          >
          
            <li
              class="pl-7"
              v-for="(item, index) in mMenu.children"
              :key="index"
              :class="{ dropdown: item.children != null }"
            >
              <a class="nav-bar" :href="item.link"
                >
                
                <!-- <v-icon v-if="index == 0" class="pl-2 white--text">
                  mdi-home-outline</v-icon
                > -->
                
                
                {{ item.text
                }}<span
                  v-if="item.children != null"
                  class="mdi mdi-chevron-down"
                ></span
              ></a>
              <div v-if="item.children != null" class="dropdown-content">
                <a
                  :href="item.link"
                  class="py-3 px-4"
                  v-for="(i, indx) in item.children"
                  :key="indx"
                  >{{ i.text }}</a
                >
              </div>
            </li>
          </ul>
          
        </v-col>
        <v-col cols="4" lg="2" md="2" sm="2" class="my-auto hide-res">
          <div
            class="white--text d-flex align-center "
            >{{ config.tel }}
            <span class="mdi mdi-phone-in-talk-outline p-fs-xxl"></span>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer
      v-model="drawer"
      app
      right
      width="60%"
      height="100vh"
      class="sidebar show-res"
    >
      <div
        @click="toggleSidebar()"
        class="drawer-hide ms-5"
        width="25"
        height="63"
        contain
        v-if="drawer"
      >
        <v-icon>mdi-close</v-icon>
      </div>
      <v-list
        :lines="false"
        density="compact"
        nav
        v-for="mMenu in menu.filter((menu) => menu.name === 'Main')"
        :key="mMenu.id"
      >
        <v-list-item
          :to="item.link"
          link
          v-for="(item, index) in mMenu.children"
          :key="index"
          color="first"
        >
          <v-list-item-content>
            <v-list-item-title
              class="d-flex align-center justify-space-between"
            >
              <v-icon class="icon-sidebar ml-2" color="first"
                >mdi-circle</v-icon
              >
              <span
                class="text-start text-p-dark p-fw-bold"
                style="width: 283px"
              >
                {{ item.text }}
              </span>
              <div class="arrow-circle">
                <v-icon class="p-fs-xl">mdi-chevron-left</v-icon>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- <v-navigation-drawer
      v-model="drawer"
      app
      right
      width="250"
      class="sidebar"
    >

      <div class="sidebar__avatar-wrapper">
        <div>
          <v-avatar size="70">
            <img
              src="@/assets/images/avatars/team-4.jpg"
              alt="profile Avatar"
            >
          </v-avatar>
          <h2>
            امیر احمدی
          </h2>
          <span>
            <i class="fas fa-id-card-alt"></i>
            amirahmadihr@gmail.com
          </span>
        </div>
      </div>

      <v-list>
        <template v-for="(nav, navIndex) in navItems">
          <v-list-item
            v-if="nav.to"
            :key="`${navIndex}-a`"
            :to="{name: nav.to}"
            link
            dark
          >
            <v-list-item-icon>
              <v-icon small>{{ nav.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ nav.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-if="nav.subItems"
            :key="`${navIndex}-b`"
            :prepend-icon="`${nav.icon} fa-em`"
            v-model="nav.active"
            append-icon="fas fa-chevron-down fa-sm"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ nav.label }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(sub, subIndex) in nav.subItems"
              :key="subIndex"
              :to="{name: sub.to}"
              link
              dark
            >
                <v-list-item-icon>
                  <v-icon small>{{ sub.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ sub.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              </v-list-group>
            </template>
          </v-list>

      <span class="sidebar-bottom-caption">
        Persian Frontend Web Application v1.2.0
      </span>

    </v-navigation-drawer> -->

    <!-- <v-app-bar
      flat
      color="trasparent"
      app
    > -->

    <!-- <v-btn
      @click="toggleSidebar()"
      class="drawer-hide"
      elevation="0"
      fab
      v-if="drawer"
    ><i class="fas fa-chevron-right"></i>
    </v-btn>
    <v-btn
      @click="toggleSidebar()"
      class="drawer-show"
      elevation="0"
      fab
      v-else
    ><i class="fas fa-bars"></i>
    </v-btn> -->

    <!-- <v-toolbar-title>
        <v-img
          :src="require('@/assets/images/logo2.png')"
          class="header-logo"
          contain
        />
      </v-toolbar-title>

      <v-spacer></v-spacer> -->

    <!-- <NotifyDropDown />

      <MessageDropDown />

      <AccountDropDown /> -->

    <!-- </v-app-bar> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import navItems from "@/containers/navbar.js";
// import AccountDropDown from "./dropDown/Account";
// import MessageDropDown from "./dropDown/Message";
// import NotifyDropDown from "./dropDown/Notify";

export default {
  name: "TheHeader",
  components: {
    // AccountDropDown,
    // MessageDropDown,
    // NotifyDropDown,
  },

  data() {
    return {
      alert,
      label,
      drawer: null,
      navItems,
      changeColor: true,
      showMenu: true,
    };
  },
  computed: {
    ...mapGetters({
      config: "operationX/config",
      menu: "operationX/menu",
    }),
  },
  beforeCreate() {
    this.$store.dispatch("operationX/getConfig");
    this.$store.dispatch("operationX/getMenu");
  },
  methods: {
    toggleSidebar() {
      this.drawer = !this.drawer;
    },
    logout() {
      this.$store.dispatch("logoutCustomer");
    },
    handleScroll(event) {
      const scroll = event.target.scrollTop || 0;
      if (scroll > 0) {
        this.changeColor = false;
      } else {
        this.changeColor = true;
      }
    },
  },
  mounted() {
    let wrapper = document.getElementById("main");
    wrapper.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    let wrapper = document.getElementById("main");
    wrapper.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
